// Use the same merchant-owned cart as Add to cart, including Vitals upsells.
// If the app is unavailable, retain the native drawer and normal cart-page link.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-mz-open-cart]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (typeof window.vtlsCartDrawer?.show === 'function') {
    try {
      window.vtlsCartDrawer.show();
      event.preventDefault();
      return;
    } catch {
      // A failed app must not make the shopper's bag inaccessible.
    }
  }
  const drawer = document.querySelector('.mz-native-actions cart-drawer-component');
  if (typeof drawer?.open !== 'function') return;
  event.preventDefault();
  drawer.open();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const branch = event.target.closest('.mz-nav-branch[open]');
  if (branch) {
    branch.open = false;
    branch.querySelector('summary')?.focus();
  }
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.mz-desktop-nav .mz-nav-branch[open]').forEach((branch) => {
    if (!branch.contains(event.target)) branch.open = false;
  });
});
